import React from 'react';

export default function LogoutScreen() {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div>You have successfully logged out</div>
    </div>
  );
}
